/* build/tpl */
import deps from './deps/keysDeep.js';
import getKeysDeep from './getKeysDeep.js';
export default getKeysDeep(deps);
